<template>
  <div class="vote-summary-container flex-row-container">
    <div class="vote-summary-item flex-row-item" v-if="showAllTickets">
      <h3>
        <span class="icon"></span>
        <span>总{{ voteText }}</span>
      </h3>
      <p>{{ data.count }}</p>
    </div>
    <div class="vote-summary-item flex-row-item" v-if="showViewCount">
      <h3>
        <span class="icon"></span>
        <span>浏览量</span>
      </h3>
      <p>{{ data.view_count }}</p>
    </div>
    <div class="vote-summary-item flex-row-item" v-if="data.type == 1 && showLeftTicket">
      <h3>
        <span class="icon"></span>
        <span>{{ leftText }}</span>
      </h3>
      <p>{{ data.surplus_ticket }}</p>
    </div>
  </div>
</template>

<script>
// NTAxOjU1Y2Jh
// this.$utils.getUrlParams("id")
export default {
  name: "VoteSummary",
  props: {
    data: {
      type: Object,
      default: () => { },
    },
    activeTab: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      voteText: "",
      leftText: "",
      showAllTickets: true,
      showViewCount: true,
      showLeftTicket: true,
    };
  },
  components: {},
  computed: {
    count() {
      return this.data.pv.count || this.data.count;
    },
    viewCount() {
      return this.data.pv.view_count || this.data.view_count;
    }
  },
  watch: {
    activeTab() {
      this.initConfig();
    }
  },
  methods: {
    // 各个配置项是否展示
    initConfig() {
      const { home_data_display } = this.data;
      this.showAllTickets = home_data_display.indexOf(1) > -1 ? true : false;
      this.showViewCount = home_data_display.indexOf(2) > -1 ? true : false;
      this.showLeftTicket = home_data_display.indexOf(3) > -1 ? true : false;
      this.voteText = this.data.button_type == 0 ? "票数" : "赞数";
      this.leftText = this.data.button_type == 0 ? "剩余票数" : "剩余赞数";
    },
  },
  mounted() {
    // console.warn("VoteSummary入参$store", this.$store.state)
    this.initConfig();
  }
};
</script>

<style scoped lang="less">
.vote-summary-container {
  margin: .2rem;
}

.flex-row-container {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;

  .flex-row-item {
    flex: 1;
    padding: 0.18rem 0;
    background: #fff;
    position: relative;

    h3 {
      font-size: 0.3rem;
      text-align: center;
      color: var(--themeColor);
      line-height: 0.52rem;

      .icon {
        margin-right: 0.1rem;
        background-repeat: no-repeat;
        background-position: center center;
      }

      span {
        display: inline-block;
        vertical-align: middle;
        line-height: 0.52rem;
        height: 0.52rem;
      }
    }

    p {
      font-size: 0.36rem;
      text-align: center;
      color: #333;
      line-height: 0.52rem;
    }
  }

  .flex-row-item::after {
    content: "";
    position: absolute;
    top: 0.3rem;
    right: 0;
    width: 0.02rem;
    height: 0.78rem;
    background: #dfdfdf;
  }

  .flex-row-item:nth-of-type(1) {
    h3 {
      .icon {
        width: 0.35rem;
        background-image: url(../assets/images/ztp.png);
        background-size: 0.35rem;
      }
    }
  }

  .flex-row-item:nth-of-type(2) {
    h3 {
      .icon {
        width: 0.41rem;
        background-image: url(../assets/images/lll.png);
        background-size: 0.41rem;
      }
    }
  }

  .flex-row-item:nth-of-type(3) {
    h3 {
      .icon {
        width: 0.36rem;
        background-image: url(../assets/images/icon-ticket.png);
        background-size: 0.36rem;
      }
    }
  }

  .flex-row-item:last-child::after {
    display: none;
  }
}
</style>